import { useState } from "react";
import Filter from "../../images/svgs/Filter";

const FilterButton = ({ filters, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(null);

  const handleSelect = (filter) => {
    setSelectedFilter(filter);
    onSelect(filter);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen((prev) => !prev)}
        className="border py-2 px-4 flex justify-between items-center gap-2 rounded-md text-[#a4a4a4] bg-white  text-sm whitespace-nowrap"
      >
        {selectedFilter || "Select Filter"} <Filter className="w-6" />
      </button>

      {isOpen && (
        <div className="absolute mt-2 bg-white border border-border-color rounded-md shadow-md w-full z-10">
          {filters.map((filter) => (
            <button
              key={filter}
              onClick={() => handleSelect(filter)}
              className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-sm"
            >
              {filter}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilterButton;
